<script>
import Dialog from '@/components/Dialog'
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import VueUtils from '@/utils/vueUtils'

export default
{
    name: 'release-notes-dialog',

    props:
    {
        release: { type: Object, required: true },
        showAdminReleaseNotes: { type: Boolean }
    },

    created ()
    {
    },

    render () 
    {
        const releaseDate = new Intl.DateTimeFormat('fr-FR', { month: 'long', year: 'numeric', day: 'numeric' }).format(new Date(this.release.date))
        const title = 'Mise à jour ' + this.release.version + ' du ' + releaseDate + (this.showAdminReleaseNotes ? ' [Édition Administrateur]' : '')
        
        var notes = this.showAdminReleaseNotes ? this.release.adminNotes : this.release.notes
        notes = notes.filter(n =>
        {
            if (n.meta && n.meta.showIf)
            {
                return eval(n.meta.showIf)
            }
            else return true
        })

        if (!notes || notes.length < 1)
        {
            console.warn(`Release notes for ${this.release.version} (admin: ${this.showAdminReleaseNotes}) not found.`)
            
            return VueUtils.destroyInstance(this)
        }

        return (
            <Dialog class='release-notes-dialog' title={title}>
                <div class='notes'>
                {
                    notes.map(note => <div class={`note ${note.type}`} domPropsInnerHTML={note.description} />)
                }
                </div>
            </Dialog>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
            promptValue: ''
        }
    },

    computed:
    {
    },

    methods:
    {
    },

    components:
    {
        Dialog,
        FloatingLabelTextInput
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.release-notes-dialog
{
    .modal
    {
        .OnDesktop({ width: 40vw !important; });

        .notes
        {
            > .note
            {
                @text-left-margin: 3px;
                margin-top: 12px;
                margin-left: @text-left-margin;

                &:first-of-type
                {
                    margin-top: 0;
                }

                &::before
                {
                    padding: 4px 8px;
                    border-radius: 5px;
                    color: white;
                    white-space: pre;
                    display: block;
                    width: fit-content;
                    margin-bottom: 3px;
                    margin-left: -@text-left-margin;
                }

                &.feature
                {
                    &::before
                    {
                        content: 'Nouveau';
                        background: #7B68EE;
                    }
                }
                &.enhancement
                {
                    &::before
                    {
                        content: 'Amélioration';
                        background: #63B47C;
                    }
                }
                &.fix
                {
                    &::before
                    {
                        content: 'Correction';
                        background: #8691A5;
                    }
                }

                code
                {
                    background-color: var(--theme-border-color);
                    padding: 3px 4px;
                    border-radius: 3px;
                    line-height: 1.8;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ReleaseNotesDialog.vue